import React, { useEffect, useState } from "react";
import Button from "../../Component/Button/Button";
import { faMapMarkerAlt, faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Style from "./ShoppingBasket.module.css";
import ShoppingList from "../ShoppingList/ShoppingList";
import AddNote from "../AddNote/AddNote";
import { UpdateProductCountInBasket } from "../../Api/BarestServices";
import { errorToast, succToast } from "../../Toast/Toast";
import { DeletebasketApi } from "../../Api/ClientServices";
import { separate } from "../../Seprate/Seprate";

const ShoppingBasket = (props) => {
  const [textNote, setTextNote] = useState();
  const [disable, setDisable] = useState(false);
  useEffect(() => {
    setTextNote(props.data.description);
  }, [props.data.description]);

  if (props.sendDescription) {
    let desc = {
      supplier_id: props.data.supplier_id,
      description: textNote,
    };

    UpdateProductCountInBasket(desc, (res) => {
      if (res.status === 1) {
        console.log("Done");
      } else {
        errorToast(res.message);
      }
    });
    setTimeout(() => props.finalize(), 500);
  }

  let TotallPrice = null;
  props.data.products.forEach((element) => {
    TotallPrice +=
      element.count *
      parseInt(element.off_price > 0 ? element.off_price : element.price);
  });

  const dataUpdate = () => {
    props.rerenderForce();
  };

  const textHandler = (e) => {
    setTextNote(e);
  };

  const deleteHandler = (id) => {
    setDisable(true);
    const supId = {
      supplier_id: id,
    };
    DeletebasketApi(supId, (suc, res) => {
      if (!suc) {
        setDisable(false);
        errorToast(res.message);
      } else {
        setDisable(false);
        succToast("حذف شد");
        props.rerenderForce();
      }
    });
  };

  return (
    <div className={Style.BasketHolder}>
      <section className={Style.RestaurantInfoHolder}>
        <div className={Style.RestaurantInfoHolder__TopPart}>
          <div className={Style.ImageHolder}>
            <img
              src={`//cdn.barest.ir/supplier/logo/${props.data.logo}.jpg`}
              alt="restaurant"
            />
          </div>
          <div className={Style.TextHolder}>
            <h3>{props.data.name}</h3>
            <div className={Style.rate}>
              <FontAwesomeIcon icon={faStar} className={Style.checked} />
              <FontAwesomeIcon icon={faStar} className={Style.checked} />
              <FontAwesomeIcon icon={faStar} className={Style.checked} />
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
            </div>
            {/* <div className={Style.AddressHolder}> */}

            <p>
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                style={{ color: "#c20c64" }}
              />{" "}
              {props.data.address}
            </p>
            {/* </div> */}
          </div>
        </div>

        <div className={Style.RestaurantInfoHolder__BottomPart}>
          <ul className={Style.ListHolder}>
            {props.data.products.map((item) => (
              <ShoppingList
                supplierId={props.data.supplier_id}
                List={item}
                key={item.id}
                onclickforce={dataUpdate}
              />
            ))}
          </ul>
          <AddNote userNote={textNote} Textfunction={textHandler} />
          <div className={Style.PriceHolder}>
            <h4>مجموع</h4>
            <strong>
              {separate(TotallPrice)} <span>تومان</span>
            </strong>
          </div>
          <div className={Style.ButtonHolder}>
            {/* <Button ClassBtn={'confrimBtn'} Value={'تکمیل خرید'}/> */}
            <Button
              ClassBtn={"confrimBtn"}
              Value={"حذف"}
              ClickHandler={() => deleteHandler(props.supID)}
              disabledProps={disable} 
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ShoppingBasket;
